import { Dropdown } from "primereact/dropdown";

export const paginatorTemplate = {
  layout:
    "RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",

  RowsPerPageDropdown: (options) => {
    const dropdownOptions = [
      { label: 10, value: 10 },
      { label: 20, value: 20 },
      { label: 50, value: 50 },
    ];
    return (
      <div className="flex items-center">
        <span
          className="mr-3 flex items-center"
          style={{ color: "var(--text-color)", userSelect: "none" }}
        >
          Rows per page:
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </span>
      </div>
    );
  },
};
